import { useState } from 'preact/hooks';
import { api } from '../api.js';
import { goBack, refreshCurrentTask, showToast, friendlyError, bumpTasksVersion } from '../store.js';
import { __ } from '../i18n.js';
import BackButton from '../components/BackButton.jsx';
import Icon from '../components/Icon.jsx';

/**
 * Roadmap §6 "Hulp nodig" consequence: when the user has a household,
 * offer "vraag [huisgenoot]" instead of just snoozing. Assigning leaves the
 * task active (still visible to the whole household) — assigned_to is
 * informational only, ETM_Engine doesn't filter eligibility on it.
 */
export default function AssignHelpScreen({ params }) {
  const [assigningId, setAssigningId] = useState(null);
  const members = params.members || [];

  async function finish() {
    await refreshCurrentTask().catch((err) => showToast(friendlyError(err), 'error'));
    goBack();
  }

  async function handleAssign(member) {
    if (assigningId) return;
    setAssigningId(member.id);
    try {
      await api.tasks.assign(params.taskId, member.id);
      showToast(__('%s is gevraagd om te helpen', 'etm').replace('%s', member.display_name), 'success');
      bumpTasksVersion(); // WP-2: keep the desktop Aankomend panel in sync
      await finish();
    } catch (err) {
      showToast(friendlyError(err), 'error');
      setAssigningId(null);
    }
  }

  return (
    <div>
      <BackButton onClick={finish} label={__('Niet nu', 'etm')} />
      <h1 class="etm-screen-title">{__('Wie kan helpen?', 'etm')}</h1>
      <p class="etm-screen-subtitle">
        {__('Vraag een huisgenoot om deze taak samen op te pakken', 'etm')}
      </p>

      <div class="etm-task-list">
        {members.map((member) => (
          <div
            key={member.id}
            class="etm-task-list-item"
            role="button"
            tabIndex={0}
            aria-disabled={assigningId !== null}
            onClick={() => handleAssign(member)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleAssign(member);
              }
            }}
          >
            <div class="etm-task-list-item__body">
              <div class="etm-task-list-item__title">
                {assigningId === member.id ? (
                  __('Bezig…', 'etm')
                ) : (
                  <>
                    <Icon name="waving_hand" size={18} /> {member.display_name}
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <button type="button" class="etm-btn etm-btn-secondary" disabled={assigningId !== null} onClick={finish}>
        {__('Niet nu', 'etm')}
      </button>
    </div>
  );
}
